import { cn } from './utils/styles';
import { useSuperbarTheme } from './hooks/useSuperbarTheme';

type TruncatedTextOverlayProps = {
  value: string;
  loading: boolean;
};

export const TruncatedTextOverlay = ({
  value,
  loading,
}: TruncatedTextOverlayProps) => {
  const theme = useSuperbarTheme();

  return (
    <div
      className={cn(
        'caddie-truncated-overlay caddie-truncated-text',
        'caddietw-absolute caddietw-inset-0 caddietw-pointer-events-none caddietw-overflow-hidden caddietw-whitespace-nowrap caddietw-font-inter caddietw-text-[16px] caddietw-font-normal caddietw-leading-[24px] caddietw-pt-[18px] caddietw-pb-[14px] caddietw-px-0',
        theme.components.inputText.className
      )}
      style={
        {
          '--caddie-truncated-color': loading
            ? theme.components.inputText.textLoading
            : theme.components.inputText.text,
          '--caddie-truncated-text-shadow':
            theme.components.inputText.textShadow,
        } as React.CSSProperties
      }
    >
      <bdi>{value}</bdi>
    </div>
  );
};
